import React from "react";
import {
  breakpointClasses,
  cls,
  cn,
  resolveElement,
  splitBreakpointProps,
} from "@/lib/utils";
import type { TypographyLargeProps } from "../types";

function TypographyLarge({
  as,
  asChild,
  className,
  ...props
}: TypographyLargeProps) {
  const Component = resolveElement(asChild, as, "span");
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  if (process.env.NODE_ENV !== "production" && as && asChild) {
    console.warn(
      `[Typography.Large] 'asChild' renders the child element; 'as' is ignored.`,
    );
  }

  return (
    <Component
      className={cn(
        cls`
          font-body
          font-semibold
          ~text-base/xl
        `,
        className,
        classes,
      )}
      {...native}
    />
  );
}

export default TypographyLarge;
